// Copyright (c) 2022 Deere & Company

import * as busyCounter from '../../../../sharedmodules/action-creators/busy-counter';
import actions from '../../../../sharedmodules/actions-list';
import { createSuccessMessage } from '../../../../sharedmodules/action-creators/alert-messages';
import { handleError } from '../../../../sharedmodules/services/error-handlers';
import { pinTransferStatusUpdate } from '../repositories/pinTransferStatusUpdate';
import { translate } from '../../../../sharedmodules/services/translation-service';

export const updateTransferStatus = (getAccessToken, data) => async (dispatch) => {

    dispatch(busyCounter.increaseBusyCounter());

    try {

        const pinTransferResponse = await pinTransferStatusUpdate(getAccessToken, data);

        dispatch(createSuccessMessage(translate('TRANSFER_UPDATED_SUCCESSFULLY')));

        dispatch({
            data: pinTransferResponse,
            type: actions.UPDATE_TRANSFER_COMMENT_SUCCESS,

        });

    } catch (error) {

        handleError(error);

    } finally {

        dispatch(busyCounter.decreaseBusyCounter());

    }

};
